import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import axios from "./utils/axios";
import PublicRoute from "./utils/PublicRoute";
import { ToastContainer } from "react-toastify";
import PrivateRoute from "./utils/PrivateRoute";
import Register from "./pages/Register";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Property from "./pages/Property";
import Configuration from "./pages/Property/config";
import Integration from "./pages/Property/integration.js";
import Rooms from "./pages/Rooms";
import RoomRate from "./pages/Rooms/roomrate.js";
import RoomFacilities from "./pages/Rooms/roomfacilities.js";
import RoomImage from "./pages/Rooms/roomimage.js";
import RatePlan from "./pages/RatePlan";
import RateSetting from './pages/RatePlan/ratesetting';
import AccountSetting from './pages/Account';
import Transaction from "./pages/Transaction";
import DetailTransaction from "./pages/Transaction/detail.js";
import RateImage from "./pages/RatePlan/rateimage.js";

function App() {

  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("token") );

  useEffect(() => {
    const handleStorageChange = () => {
      setIsAuthenticated(!!localStorage.getItem("token")); // Update state on token change
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <Router> 
      <Routes>
        {/* Public Route */}
        <Route path="/" element={<Login isAuthenticated={isAuthenticated} />} />

        {/* Private Routes */}
        <Route path="/dashboard" element={<Dashboard isAuthenticated={isAuthenticated} />} />

        
        <Route path="/property/:hotel_id/:url" element={<Property />} />
        <Route path="/configuration/:hotel_id/" element={<Configuration />} />
        <Route path="/integration/:hotel_id/" element={<Integration />} />
        <Route path="/rooms/:hotel_id/" element={<Rooms />} />
        <Route path="/rooms/image/:hotel_id/" element={<RoomImage />} />
        <Route path="/rooms/rate/:hotel_id/" element={<RoomRate />} />
        <Route path="/rooms/facilities/:hotel_id/" element={<RoomFacilities />} />
        <Route path="/room-rate/:hotel_id/" element={<RatePlan />} />
        <Route path="/rate-setting/:hotel_id/" element={<RateSetting />} />
        <Route path="/rate-image/:hotel_id/" element={<RateImage />} />
        <Route path="/transaction/:hotel_id/" element={<Transaction />} />
        <Route path="/detail/transaction/:gphone/" element={<DetailTransaction />} />
        <Route path="/account-setting/" element={<AccountSetting />} />
      </Routes>

      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </Router> 
  );
}

export default App;
